import "./App.css";
import "../src/CSS/index.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import HomePage from "./Pages/HomePage";
import Designing from "./Pages/Designing";
import DesigningDetail from "./Pages/DesigningDetail";
import Printing from "./Pages/Printing";
import PrintingDetail from "./Pages/PrintingDetail";
import OttApp from "./Pages/OttApp";
import Cart from "./Pages/Cart";
import CorporrateGiftingHome from "./Pages/CorporrateGiftingHome";
import CorporateAllProducts from "./Pages/CorporateAllProducts";
import PrintingProducts from "./Pages/PrintingProducts";
import DMHomePage from "./Pages/DMHomePage";
import DMServiceDetail from "./Pages/DMServiceDetail";
import MyInfo from "./Pages/MyInfo";
import Advertising from "./Pages/Advertising";
import AboutUs from "./Pages/AboutUs";
import AdsPage from "./Pages/AdsPage";
import Login from "./Pages/Auth/Login";
import Register from "./Pages/Auth/Register";
import { AuthProvider } from "./authContext";
import { CartProvider } from "./cartContext";
import MyOrders from "./Pages/MyOrders";
import InfluencerMarketing from "./Pages/InfluencerMarketing";
import BrandEndorsement from "./Pages/BrandEndorsement";
import ScrollToTop from "./components/ScrollToTop";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import CategoryDetails from "./Pages/CategoryDetails";
import NewspaperDetails from './Pages/NewspaperDetails';
import ResetPassword from "./Pages/ResetPassword.jsx";
import InfluencerDetail from "./Pages/InfluencerDetail";
import BrandEndorsementDetail from "./Pages/BrandEndorsementDetail";
import LegalPage from "./Pages/LegalPage";
import NotFound from "./Pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset/:token" element={<ResetPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/advertising" element={<Advertising />} />
            <Route path="/designing" element={<Designing />} />
            <Route path="/designing/:identifier" element={<DesigningDetail />} />
            <Route path="/printing" element={<Printing />} />
            <Route
              path="/printing/:identifier"
              element={<PrintingDetail />}
            />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/app" element={<OttApp />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/myinfo" element={<MyInfo />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/t&c" element={<LegalPage page="terms" />} />
            <Route path="/terms-and-conditions" element={<LegalPage page="terms" />} />
            <Route path="/privacy-policy" element={<LegalPage page="privacy" />} />
            <Route path="/refund-cancellation" element={<LegalPage page="refund" />} />
            <Route path="/corporratehome" element={<CorporrateGiftingHome />} />
            <Route path="/influencer-marketing" element={<InfluencerMarketing />} />
            {/* <Route path="/influencer-marketing/:id" element={<InfluencerList />} /> */}
            <Route path="/influencer-marketing/:slug" element={<InfluencerDetail />} />
            <Route path="/brand-endorsement" element={<BrandEndorsement />} />
            {/* <Route path="/brand-endorsement/:id" element={<BrandEndorsementList />} /> */}
            <Route path="/brand-endorsement/:slug" element={<BrandEndorsementDetail />} />
            <Route
              path="/corporrateallproducts"
              element={<CorporateAllProducts />}
            />
            <Route path="/newspaper/:slug" element={<NewspaperDetails />} />
            {/* Advertising category routes with /advertising/category-ads/slug */}
            <Route path="/advertising/:category" element={<AdsPage />} />
            <Route path="/advertising/:category/:slug" element={<CategoryDetails />} />

            {/* Individual Advertising Category Routes */}
            <Route path="/advertising/radio-ads" element={<AdsPage categoryName="radio" />} />
            <Route path="/advertising/radio-ads/:slug" element={<CategoryDetails categoryName="radio" />} />
            <Route path="/advertising/transit-ads" element={<AdsPage categoryName="transit" />} />
            <Route path="/advertising/transit-ads/:slug" element={<CategoryDetails categoryName="transit" />} />
            <Route path="/advertising/cinema-ads" element={<AdsPage categoryName="cinema" />} />
            <Route path="/advertising/cinema-ads/:slug" element={<CategoryDetails categoryName="cinema" />} />
            <Route path="/advertising/outdoor-ads" element={<AdsPage categoryName="outdoor" />} />
            <Route path="/advertising/outdoor-ads/:slug" element={<CategoryDetails categoryName="outdoor" />} />
            <Route path="/advertising/btl-ads" element={<AdsPage categoryName="btl" />} />
            <Route path="/advertising/btl-ads/:slug" element={<CategoryDetails categoryName="btl" />} />
            <Route path="/advertising/non-traditional-ads" element={<AdsPage categoryName="non-traditional" />} />
            <Route path="/advertising/non-traditional-ads/:slug" element={<CategoryDetails categoryName="non-traditional" />} />
            <Route path="/advertising/digital-ads" element={<AdsPage categoryName="digital" />} />
            <Route path="/advertising/digital-ads/:slug" element={<CategoryDetails categoryName="digital" />} />
            <Route path="/advertising/newspaper-ads" element={<AdsPage categoryName="newspaper" />} />
            <Route path="/advertising/newspaper-ads/:slug" element={<CategoryDetails categoryName="newspaper" />} />

            {/* Legacy advertising category routes */}
            <Route path="/radio-advertising" element={<AdsPage categoryName="radio" />} />
            <Route path="/radio-advertising/:slug" element={<CategoryDetails categoryName="radio" />} />
            <Route path="/transit-advertising" element={<AdsPage categoryName="transit" />} />
            <Route path="/transit-advertising/:slug" element={<CategoryDetails categoryName="transit" />} />
            <Route path="/cinema-advertising" element={<AdsPage categoryName="cinema" />} />
            <Route path="/cinema-advertising/:slug" element={<CategoryDetails categoryName="cinema" />} />
            <Route path="/outdoor-advertising" element={<AdsPage categoryName="outdoor" />} />
            <Route path="/outdoor-advertising/:slug" element={<CategoryDetails categoryName="outdoor" />} />
            <Route path="/btl-advertising" element={<AdsPage categoryName="btl" />} />
            <Route path="/btl-advertising/:slug" element={<CategoryDetails categoryName="btl" />} />
            <Route path="/non-traditional-advertising" element={<AdsPage categoryName="non-traditional" />} />
            <Route path="/non-traditional-advertising/:slug" element={<CategoryDetails categoryName="non-traditional" />} />
            <Route path="/digital-advertising" element={<AdsPage categoryName="digital" />} />
            <Route path="/digital-advertising/:slug" element={<CategoryDetails categoryName="digital" />} />
            <Route path="/newspaper-advertising" element={<AdsPage categoryName="newspaper" />} />
            <Route path="/newspaper-advertising/:slug" element={<CategoryDetails categoryName="newspaper" />} />
            <Route path="/printingproducts" element={<PrintingProducts />} />
            <Route path="/digital-marketing" element={<DMHomePage />} />
            <Route path="/services/influencer" element={<Navigate to="/influencer-marketing" replace />} />
            <Route path="/services/influencer-marketing" element={<Navigate to="/influencer-marketing" replace />} />
            <Route path="/digital-marketing/services/influencer" element={<Navigate to="/influencer-marketing" replace />} />
            <Route path="/digital-marketing/services/influencer-marketing" element={<Navigate to="/influencer-marketing" replace />} />
            <Route path="/digital-marketing/influencer" element={<Navigate to="/influencer-marketing" replace />} />
            <Route path="/digital-marketing/influencer-marketing" element={<Navigate to="/influencer-marketing" replace />} />
            <Route path="/digital-marketing/services/:slug" element={<DMServiceDetail />} />
            <Route path="/digital-marketing/:slug" element={<DMServiceDetail />} />
            <Route path="/services/:slug" element={<DMServiceDetail />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <FloatingWhatsApp />
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
